import { render, staticRenderFns } from "./VacanciesIcon.vue?vue&type=template&id=4aa34af5"
import script from "./VacanciesIcon.vue?vue&type=script&lang=js"
export * from "./VacanciesIcon.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../account/node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports